import { AxFireShoppingCartModal } from "./Components/AxFireShoppingCartModal/AxFireShoppingCartModal";
import { AxLoad } from "./Lib/AxSystem/AxLoad";
import { inputMaskHelper } from './Lib/Helper/InputMaskHelper';
import { AxLimeStone } from "./Limestone/AxLimeStone";
import { CustomerLessonProperties } from "./Modules/Account/CustomerLessonProperties";
import { MissingMandatoryData } from "./Modules/Account/MissingMandatoryData";
import { RegisterForm } from "./Modules/Account/RegisterForm";
import { Registration } from "./Modules/Account/Registration";
import { AxStaticConfigModule } from "./Modules/AxConfig/AxStaticConfigModule";
import { AxGA4Module } from "./Modules/AxGA4/AxGA4Module";
import { AxPixelTracking } from "./Modules/AxMetaTracking/AxPixelTracking";
import { AxProdDetail } from "./Modules/AxProdSelection/AxProdDetail";
import { AxProdMain } from "./Modules/AxProdSelection/AxProdMain";
import { AxProdSelection } from "./Modules/AxProdSelection/AxProdSelection";
import { AxProdSummary } from "./Modules/AxProdSelection/AxProdSummary";
import * as LandingQuickSelection from "./Modules/AxProdSelection/LandingQuickSelection";
import { AxPackBooking } from "./Modules/AxProdSelection/Packages/AxPackBooking";
import { AxPackNonPredateable } from "./Modules/AxProdSelection/Packages/AxPackNonPredateable";
import { AxPackPredateable } from "./Modules/AxProdSelection/Packages/AxPackPredateable";
import { AxPackSelectionCalendar } from "./Modules/AxProdSelection/Packages/AxPackSelectionCalendar";
import { AxProdBooking } from "./Modules/AxProdSelection/Tickets/AxProdBooking";
import { AxProdNonPredateable } from "./Modules/AxProdSelection/Tickets/AxProdNonPredateable";
import { AxProdPredateable } from "./Modules/AxProdSelection/Tickets/AxProdPredateable";
import { AxProdSelectionCalendar } from "./Modules/AxProdSelection/Tickets/AxProdSelectionCalendar";
import { B2BHistory } from "./Modules/B2B/B2BHistory";
import { B2bMode } from "./Modules/B2B/B2bMode";
import { BleQrCodes } from "./Modules/Ble/BleQrCodes";
import { CategoryFilter } from "./Modules/Categories/CategoryFilter";
import { ComplexPackageBookingTicketsOptions } from "./Modules/ComplexPackages/BookingOptions/ComplexPackageBookingTicketsOptions";
import { CompPackBookingLessonOptions } from "./Modules/ComplexPackages/BookingOptions/CompPackBookingLessonOptions";
import { CompPackBookingLessonProgramOptions } from "./Modules/ComplexPackages/BookingOptions/CompPackBookingLessonProgramOptions";
import { CompPackBookingPersonOptions } from "./Modules/ComplexPackages/BookingOptions/CompPackBookingPersonOptions";
import { CompPackBookingRentalOptions } from "./Modules/ComplexPackages/BookingOptions/CompPackBookingRentalOptions";
import { ComplexPackageBookingOptions } from "./Modules/ComplexPackages/ComplexPackageBookingOptions";
import { ComplexPackageDetails } from "./Modules/ComplexPackages/ComplexPackageDetails";
import { ComplexPackageFilter } from "./Modules/ComplexPackages/ComplexPackageFilter";
import { ComplexPackageSearchBar } from "./Modules/ComplexPackages/ComplexPackageSearchBar";
import { ComplexPackageSelection } from "./Modules/ComplexPackages/ComplexPackageSelection";
import { ConsentDocuments } from "./Modules/ConsentDocuments/ConsentDocuments";
import { ServerErrorPopUp } from "./Modules/ErrorHandling/ServerErrorPopUp";
import { FindMyTicket } from "./Modules/FindMyTicket/FindMyTicket";
import { MainGiftCards } from "./Modules/GiftCard/MainGiftCards";
import { PersonalizeGiftCard } from "./Modules/GiftCard/PersonalizeGiftCard";
import { AxBirthDateInputTriple } from "./Modules/Global/AxBirthDateInputTriple";
import { AxTopBar } from "./Modules/Global/AxTopBar";
import { Banner } from "./Modules/Global/Banner";
import { DateModule } from "./Modules/Global/DateModule";
import { LocalizationModule } from "./Modules/Global/LocalizationModule";
import { SubmenuAim } from "./Modules/Global/SubmenuAim";
import { UtilityInit } from "./Modules/Global/UtilityInit";
import { HeroModule } from "./Modules/Hero/HeroModule";
import { Invoice } from "./Modules/Invoice/Invoice";
import * as LessonPackagesLandingPage from "./Modules/LessonPackages/LandingPage";
import { LessonPackageStorage } from "./Modules/LessonPackages/LessonPackageStorage";
import * as LessonPackagesPersonalization from "./Modules/LessonPackages/Personalization";
import * as LessonPackagesSelection from "./Modules/LessonPackages/Selection";
import { LessonBuyerInfoModule } from "./Modules/Lessons/LessonBuyerInfoModule";
import { LessonsLoadingSpinner } from "./Modules/Lessons/LessonsLoadingSpinner";
import { LinkedArticleWaiver } from "./Modules/LinkedArticleWaiver/LinkedArticleWaiver";
import { MaintenanceScriptInfo } from "./Modules/MaintenanceMode/MaintenanceScriptInfo";
import { Resubscribe } from "./Modules/NewsLetterSubscription/Resubscribe";
import { Unsubscribe } from "./Modules/NewsLetterSubscription/Unsubscribe";
import { OneRisk } from "./Modules/OneRisk/OneRisk";
import { PackageMinMaxConstraint } from "./Modules/Packages/PackageMinMaxConstraint";
import { RazorPaginator } from "./Modules/Paginator/RazorPaginator";
import { Eguma } from "./Modules/Payment/Eguma";
import { Payment } from "./Modules/Payment/Payment";
import { VoucherPayment } from "./Modules/Payment/VoucherPayment";
import { Membership } from "./Modules/Profile/Membership";
import { MyChipCards } from "./Modules/Profile/MyChipCards";
import { MyFamily } from "./Modules/Profile/MyFamily";
import { OrderHistory } from "./Modules/Profile/OrderHistory";
import { PasswordValidation } from "./Modules/Profile/PasswordValidation";
import { Accessibility } from "./Modules/ProfileSettings/Accessibility";
import { PersonalData } from "./Modules/ProfileSettings/PersonalData";
import { Redirect } from "./Modules/Redirect/Redirect";
import { RentalProductDetails } from "./Modules/Rental/ProductDetails/RentalProductDetails";
import { RentalFilter } from "./Modules/Rental/RentalFilter";
import { RentalMain } from "./Modules/Rental/RentalMain";
import { RentalShopDetails } from "./Modules/Rental/RentalShopDetails";
import * as RentalDetails from "./Modules/Rental/RiderDetails/RiderDetailsModule";
import { Reserved } from "./Modules/Reservations/Reserved";
import { SeasonCardBooking } from "./Modules/Reservations/SeasonCardBooking";
import { TimeSlots } from "./Modules/Reservations/TimeSlots";
import { RetailDetail } from "./Modules/Retail/RetailDetail";
import { RetailFilter } from "./Modules/Retail/RetailFilter";
import { RetailMain } from "./Modules/Retail/RetailMain";
import { ServiceVoucherPersonalization } from "./Modules/ServiceVoucher/ServiceVoucherPersonalization";
import { ServiceVoucherRedeem } from "./Modules/ServiceVoucher/ServiceVoucherRedeem";
import { Shipping } from "./Modules/Shipping/Shipping";
import { CartEntryQuantity } from "./Modules/ShoppingCart/CartEntryQuantity";
import { OneRiskNotification } from "./Modules/ShoppingCart/OneRiskNotification";
import { PopUpShoppingCart } from "./Modules/ShoppingCart/PopUpShoppingCart";
import { ShoppingCart } from "./Modules/ShoppingCart/ShoppingCart";
import { ShoppingCartDateInputTriple } from "./Modules/ShoppingCart/ShoppingCartDateInputTriple";
import { ShoppingCartEntryRetail } from "./Modules/ShoppingCart/ShoppingCartEntryRetail";
import { ShoppingCartPersonalisation } from "./Modules/ShoppingCart/ShoppingCartPersonalisation";
import { ShoppingCartReservationTimer } from "./Modules/ShoppingCart/ShoppingCartReservationTimer";
import { ToCheckout } from "./Modules/ShoppingCart/ToCheckout";
import { AxFilterOverlay } from "./Utility/AxFilterOverlay";
import { AxMain } from "./Utility/AxMain";
import { I18nHelper } from "./Lib/Helper/I18nHelper";

export class App extends AxMain {
    declarations = [
        Payment,
        AxTopBar,
        AxProdDetail,
        AxProdMain,
        AxProdSelection,
        LessonPackagesLandingPage.LandingPage,
        LessonPackagesSelection.Selection,
        LessonPackagesPersonalization.Personalization,
        AxProdSelectionCalendar,
        AxProdBooking,
        AxPackBooking,
        AxProdNonPredateable,
        AxProdSummary,
        LandingQuickSelection.LandingQuickSelection,
        AxProdPredateable,
        AxPackPredateable,
        AxPackNonPredateable,
        AxPackSelectionCalendar,
        ShoppingCart,
        CategoryFilter,
        ToCheckout,
        RentalShopDetails,
        Registration,
        B2BHistory,
        ShoppingCart,
        SeasonCardBooking,
        TimeSlots,
        LessonPackageStorage,
        VoucherPayment,
        Reserved,
        OrderHistory,
        ComplexPackageFilter,
        ComplexPackageSelection,
        ConsentDocuments,
        ComplexPackageDetails,
        Eguma,
        AxBirthDateInputTriple,
        SubmenuAim,
        RetailDetail,
        RetailMain,
        RetailFilter,
        RentalMain,
        RentalFilter,
        Shipping,
        OrderHistory,
        ComplexPackageBookingOptions,
        Membership,
        ComplexPackageBookingTicketsOptions,
        CompPackBookingLessonProgramOptions,
        CompPackBookingPersonOptions,
        CompPackBookingRentalOptions,
        CompPackBookingLessonOptions,
        PasswordValidation,
        MyChipCards,
        Redirect,
        LessonsLoadingSpinner,
        MyFamily,
        ShoppingCartEntryRetail,
        ComplexPackageSearchBar,
        ShoppingCartPersonalisation,
        FindMyTicket,
        UtilityInit,
        ShoppingCartReservationTimer,
        PersonalizeGiftCard,
        MainGiftCards,
        AxFireShoppingCartModal,
        AxGA4Module,
        AxStaticConfigModule,
        ServerErrorPopUp,
        HeroModule,
        Banner,
        Unsubscribe,
        Resubscribe,
        PersonalData,
        MissingMandatoryData,
        MaintenanceScriptInfo,
        PopUpShoppingCart,
        RegisterForm,
        PackageMinMaxConstraint,
        BleQrCodes,
        ShoppingCartDateInputTriple,
        RentalProductDetails,
        LocalizationModule,
        RentalDetails.RiderDetailsModule,
        DateModule,
        OneRiskNotification,
        OneRisk,
        CustomerLessonProperties,
        LessonBuyerInfoModule,
        CartEntryQuantity,
        LinkedArticleWaiver,
        RazorPaginator,
        Accessibility,
        ServiceVoucherPersonalization,
        ServiceVoucherRedeem,
        Invoice,
        AxPixelTracking,
    ];

    utility = [
        inputMaskHelper,
        AxFilterOverlay,
        AxLimeStone,
        I18nHelper,
    ];

    providers = [
        AxLoad,
        B2bMode
    ];

    constructor() {
        super();
        this.Init();
    }
}


window["App"] = App;